// Neutral Colors
const WHITE = "#FFFFFF";
const BLACK = "#000000";

// Accent #1 - Raisin
const RAISIN_10 = "#D6D6D8";
const RAISIN_20 = "#EBEAEC";
const RAISIN_40 = "#AEACB1";
const RAISIN_50 = "#99979E";
const RAISIN_70 = "#716E77";
const RAISIN_80 = "#5D5964";
const RAISIN_100 = "#34303D";
const DARK_RAISIN = "#26242D";

// Accent #2 - Turquoise
const TURQUOISE_20 = "#E6FAFA";
const TURQUOISE_40 = "#99EDED";
const TURQUOISE_50 = "#80E8E8";
const TURQUOISE_80 = "#33DADB";
const TURQUOISE_100 = "#00D1D2";

// Additional colors
const WARM_WHITE = "#FFFDFB";
const ISABELLINE = "#F6F4F0";
const ISABELLINE_DARKER = "#E3E0DE";

const WILD_SAND = "#F5F5F5";
const ATHENS = "#EDEEF1";
const IRON = "#CACCCE";
const EMPEROR = "#505050";
const MINE = "#282828";
const GRAY = "#00000029";
const COD_GRAY = "#1B1B1B";
const BLACKISH = "#131313";
const LIGHT_GRAY = "#E2E2E2";

const OC_GRAY_2 = "#E9ECEF";

const DAWN = "#F3EDE8";
const DUST = "#CFB2A0";

const MANDY = "#E55252";

const JUNGLE = "#29BD91";
const SALEM = "#0B7F5C";

const ERROR = "#C73636";
const SUCCESS = "#2BBA99";
const BLUE = "#404FCF";

const colors = {
  WHITE,
  BLACK,
  RAISIN_10,
  RAISIN_20,
  RAISIN_40,
  RAISIN_50,
  RAISIN_70,
  RAISIN_80,
  RAISIN_100,
  DARK_RAISIN,
  TURQUOISE_20,
  TURQUOISE_40,
  TURQUOISE_50,
  TURQUOISE_80,
  TURQUOISE_100,
  WARM_WHITE,
  ISABELLINE,
  ISABELLINE_DARKER,
  WILD_SAND,
  ATHENS,
  IRON,
  EMPEROR,
  MINE,
  GRAY,
  COD_GRAY,
  BLACKISH,
  LIGHT_GRAY,
  OC_GRAY_2,
  DAWN,
  DUST,
  MANDY,
  JUNGLE,
  SALEM,
  ERROR,
  SUCCESS,
  BLUE
};

export default colors;
